<template>
    <div class="hts-distributing__detail">
        <schedule-map
            v-if="showMap"
            :journey="selectedJourney" />
        <div
            ref="journeySchedule"
            v-loading="vehicleLoading"
            class="hts-distributing__detail-info p-1 gap-1">
            <div class="flex-initial">
                <div
                    :class="{ hidden: !showManualSelection }"
                    class="inline-block align-middle mt-1 mr-1">
                    <hts-form-button
                        color="info"
                        icon-name="hi-check-icon"
                        :outline="false"
                        :loading="manualLoading"
                        @click="manualScheduleConfirm">
                        {{ $t('labels.confirm') }}
                    </hts-form-button>
                    <hts-form-button @click="manualScheduleCancel">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
                <hts-form-input
                    v-model="search"
                    placeholder="Nhập biển số xe"
                    class="w-80 mt-1 mr-1 inline-block align-middle">
                    <template #prefix>
                        <hts-icons icon-name="hi-magnifying-glass-icon" />
                    </template>
                </hts-form-input>

                <div class="float-right flex gap-3">
                    <hts-map-icon-location store-key="distributing" />
                    <hts-map-icon-map store-key="distributing" />
                    <hts-map-icon-journey />
                </div>
            </div>
            <schedule-board
                ref="scheduleBoard"
                :loading="vehicleLoading"
                :show-manual-selection="showManualSelection"
                :search="search"
                @item-click="handleItemClick"
                @selection-change="handleSelectionChange" />
        </div>
    </div>
</template>
<script setup lang="ts">
import ScheduleMap from './journey-schedule/map.vue'
import ScheduleBoard from './journey-schedule/board.vue'

const { map } = $store()

const showMap = computed(() => {
  return map.getShowMap.distributing
})

const showJourey = computed(() => {
  return map.getShowJourney.distributing
})

const emits = defineEmits(['change'])
const { $eventBus } = useNuxtApp()
const selectedJourney = ref(undefined)
const journeySchedule: any = ref(null)
const scheduleBoard: any = ref(null)

const showManualSelection = ref(false)

const search = ref('')

const vehicleLoading = ref(true)
const vehicles = ref<any[]>([])
const vehicleLength = computed(() => vehicles.value.length)

const manualItem: any = ref(null)
const manualSelectedVehicle = ref(null)
const manualLoading = ref(false)
const manualErrors = ref<any[]>([])
const manualInputVisible = ref<boolean>(false)
const manualConfirmVisible = ref<boolean>(false)

onMounted(() => {
  getVehicles()
})

watch(
  () => search.value,
  (val: string) => {}
)

watch(
  () => showMap.value,
  (val: boolean) => {
    scheduleBoard.value && scheduleBoard.value.onResize()
  }
)

watch(
  () => showJourey.value,
  (val: boolean) => {
    scheduleBoard.value && scheduleBoard.value.onResize()
  }
)

const showBackdrop = () => {
  $eventBus.emit('global-backdrop-show', { target: journeySchedule.value, options: { closeable: false } })
}
const hideBackdrop = () => {
  $eventBus.emit('global-backdrop-hide')
}

const getVehicles = () => {
  vehicleLoading.value = true
  $api($urlPartner.journey.getVehicles, { query: { skip: vehicleLength.value } })
    .then(({ data }: any) => {
      const temp = (data?.value || {}).data || []
      if (Array.isArray(temp)) {
        vehicles.value = [...vehicles.value, ...temp]
      }
      scheduleBoard.value && scheduleBoard.value.setRows(vehicles.value)
      vehicleLoading.value = false
    })
    .catch(() => {
      vehicleLoading.value = false
    })
}

const manualSchedule = (item: any) => {
  if (!item) {
    return
  }
  manualItem.value = item
  showManualSelection.value = true
  showBackdrop()
}
const manualScheduleCancel = () => {
  deleteItem(manualItem.value)
  manualHide()
}
const manualData = reactive({
  startAt: '',
  startAtNodeId: '',
  locations: []
})
const manualScheduleConfirm = () => {
  if (!manualItem.value) {
    return $toast().error('Bạn chưa chọn chặng')
  }
  if (!manualSelectedVehicle.value) {
    return $toast().error('Bạn chưa chọn xe')
  }

  manualLoading.value = true
  manualErrors.value = []
  $api($urlPartner.journey.schedule.manual, { body: { journeyId: manualItem.value._id, vehicleId: manualSelectedVehicle.value, manualData } })
    .then(({ data }) => {
      manualItem.value.vehicleId = manualSelectedVehicle.value
      scheduleBoard.value.setItem(manualSelectedVehicle.value, manualItem.value)
      emits('change')
      manualLoading.value = false
      manualHide()
    })
    .catch(() => {
      manualLoading.value = false
    })
}
const manualHide = () => {
  showManualSelection.value = false
  manualSelectedVehicle.value = null
  scheduleBoard.value.clearSelection()
  hideBackdrop()
}
const handleSelectionChange = (id: any, val: boolean) => {
  if (!scheduleBoard.value || !manualItem.value) {
    return
  }
  manualSelectedVehicle.value = id
  scheduleBoard.value.setItem(id, manualItem.value)
}

const handleItemClick = (item: any) => {
  selectedJourney.value = item
}

const selectJourney = (item: any) => {
  handleItemClick(item)
}

const getRows = () => {
  return scheduleBoard.value.getRows()
}

const addRow = (data: { [key: string]: any }) => {
  return scheduleBoard.value.addRow(data)
}

const getRowById = (id: string) => {
  return scheduleBoard.value.getRowById(id)
}

const addItems = (items: any[]) => {
  if (!Array.isArray(items)) {
    return
  }
  return scheduleBoard.value.addItems(null, items)
}

const setItem = (id: string, data: any) => {
  return scheduleBoard.value.setItem(id, data)
}
const deleteItem = (data: any) => {
  return scheduleBoard.value && scheduleBoard.value.deleteItem(data)
}

const updateAndAddItem = (id: string, data: any) => {
  return scheduleBoard.value.updateAndAddItem(id, data)
}
defineExpose({ manualSchedule, getRows, getRowById, addItems, setItem, deleteItem, updateAndAddItem, addRow, selectJourney })
</script>
